var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Column_1;
import { JSON, JsonSchema } from '@symon-ai/wisepipe-serialize';
import * as random from 'random-seed';
// eslint-disable-next-line import/no-duplicates
import './periodColumnMetadata'; // force import for JsonSchema
export const COLUMN_NAME_MAX_LENGTH = 150;
const schema = {
    $id: 'urn:wisepipe-common-data:Column',
    type: 'object',
    properties: {
        name: { type: 'string', minLength: 1, maxLength: COLUMN_NAME_MAX_LENGTH },
        type: { type: 'string', pattern: 'number|date|string|boolean|decimal|period' },
        metadata: { oneOf: [{ $ref: 'urn:wisepipe-common-data:PeriodColumnMetadata' }] }
    },
    required: ['name', 'type'],
    if: { properties: { type: { type: 'string', pattern: 'period' } } },
    then: { required: ['metadata'] }
};
let Column = Column_1 = class Column {
    constructor(name, type, metadata) {
        this.name = name;
        this.type = type;
        if (metadata !== undefined)
            this.metadata = metadata;
        JSON.validate(this, Column_1);
    }
    static random(seed) {
        const rand = random.create(seed);
        const size = rand(40);
        const columns = [];
        const names = new Set();
        while (columns.length < size) {
            const column = Column_1.randomColumn(rand);
            if (names.has(column.name))
                continue;
            columns.push(column);
            names.add(column.name);
        }
        return columns;
    }
    static randomColumn(rand) {
        return new Column_1(Column_1.randomName(rand), Column_1.randomType(rand));
    }
    static randomName(rand) {
        const MAX_SIZE = 50;
        const word = [];
        const uppers = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const first = uppers[rand(uppers.length)];
        word.push(first);
        const size = rand(MAX_SIZE - 1);
        const lowers = 'abcdefghijklmnopqrstuvwxyz0123456789_ ';
        while (word.length < size) {
            const index = rand(lowers.length);
            const char = lowers[index];
            word.push(char);
        }
        return word.join('').trim();
    }
    static randomType(rand) {
        const r = rand(3);
        switch (r) {
            case 0:
                return 'date';
            case 1:
                return 'string';
            case 2:
            default:
                return 'number';
        }
    }
    toString() {
        return JSON.stringify(this);
    }
};
Column = Column_1 = __decorate([
    JsonSchema(schema)
], Column);
export { Column };
//# sourceMappingURL=column.js.map